/**
 * Alles ophalen, ook als het meer dan één pagina is.
 *
 * De server geeft standaard hoogstens duizend rijen terug. Op een klein
 * evenement valt dat niet op, maar een festivaldag levert makkelijk tienduizend
 * bonregels op — en dan zou de afrekening stilletjes met een deel van de omzet
 * rekenen. Daarom halen we altijd door tot er niets meer komt.
 */

const PAGINA = 1_000;

export interface PaginaResultaat<T> {
  data: T[] | null;
  error: { message: string } | null;
}

export async function haalAlles<T>(
  pagina: (van: number, tot: number) => PromiseLike<PaginaResultaat<T>>,
): Promise<T[]> {
  const alles: T[] = [];

  for (let van = 0; ; van += PAGINA) {
    const { data, error } = await pagina(van, van + PAGINA - 1);
    if (error) throw new Error(error.message);
    const rijen = data ?? [];
    alles.push(...rijen);
    if (rijen.length < PAGINA) break;
  }

  return alles;
}
